import axios from 'axios';
import logger from './logger';

// Determina l'URL base in base all'ambiente
const baseURL = process.env.NODE_ENV === 'production'
  ? '/api'  // In produzione usa il path relativo
  : 'http://localhost:5000/api';  // In sviluppo usa localhost

logger.debug('🌐 Ambiente:', process.env.NODE_ENV);
logger.debug('🔗 Base URL:', baseURL);

// Create axios instance
export const api = axios.create({
  baseURL,
  timeout: 120000 // Aumentiamo il timeout da 60 a 120 secondi per operazioni lente
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    logger.debug('🔄 Interceptor - Preparazione richiesta:', config.url);
    
    // Add token to request header
    const token = localStorage.getItem('token');
    if (token) {
      logger.debug('🔑 Token trovato, imposto header Authorization');
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Add company ID to request header
    const companyId = localStorage.getItem('selectedCompanyId');
    if (companyId) {
      logger.debug('🏢 Company ID trovato, imposto header X-Company-ID');
      config.headers['X-Company-ID'] = companyId;
    }

    return config;
  },
  (error) => {
    logger.error('❌ Errore nell\'interceptor delle richieste:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    logger.debug('✅ Risposta ricevuta:', response.config.url);
    
    // Save company ID from response header
    const companyId = response.headers['x-company-id'];
    if (companyId) {
      logger.debug('🏢 Company ID ricevuto nella risposta:', companyId);
      localStorage.setItem('selectedCompanyId', companyId);
      api.defaults.headers.common['X-Company-ID'] = companyId;
    }
    
    return response;
  },
  (error) => {
    if (error.response) {
      // Handle 404 errors
      if (error.response.status === 404) {
        logger.warn('⚠️ Endpoint non trovato:', error.config.url);
        logger.debug('Possibile causa: rotta non implementata sul server di produzione');
      }
      // Handle other errors
      else {
        logger.error('❌ Errore nella risposta:', error.response.status, error.response.data);
      }
    } else if (error.request) {
      logger.error('❌ Nessuna risposta ricevuta:', error.request);
    } else {
      logger.error('❌ Errore nella configurazione della richiesta:', error.message);
    }
    return Promise.reject(error);
  }
);

// Funzione per impostare il token
export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    localStorage.setItem('token', token);
  } else {
    delete api.defaults.headers.common['Authorization'];
    localStorage.removeItem('token');
  }
};

// Funzione per impostare l'ID dell'azienda
export const setCompanyId = (companyId) => {
  if (companyId) {
    api.defaults.headers.common['X-Company-ID'] = companyId;
    localStorage.setItem('selectedCompanyId', companyId);
    localStorage.setItem('companyId', companyId); // Salva anche con questo nome per compatibilità
    logger.debug('🏢 Company ID salvato:', companyId);
  } else {
    delete api.defaults.headers.common['X-Company-ID'];
    localStorage.removeItem('selectedCompanyId');
    localStorage.removeItem('companyId');
  }
};

// Export default per compatibilità con i vecchi import
export default api;
